<script>
export default {
  name: 'BannerContainer',

  props: {
    title: {
      type: String,
      required: true,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    // for CSS purposes
    className: {
      type: String,
      required: true,
    },
  },

  computed: {
    maxWidth() {
      return this.$vuetify.breakpoint.smAndUp ? 100 : 60;
    },
  },
};
</script>

<template>
  <div :class="className" class="banner-content" v-bind="$attrs">
    <div
      class="banner-title text-subtitle-1 text-sm-h6 semi text-left text-lg-left mb-3 mb-md-4 ml-5"
    >
      {{ title }}
    </div>
    <div class="card-wrapper position-relative">
      <div class="card-container d-flex align-center w-full h-full">
        <div
          class="d-flex"
        >
          <v-img v-reload-on-fail
                 :max-height="maxWidth"
                 :max-width="maxWidth"
                 :src="imageSrc"
                 class="img mr-3"
                 contain
          />
          <v-divider class="white" style="height: auto" vertical/>
        </div>

        <div
          class="card-content w-full h-full d-flex flex-column justify-space-between pl-3"
        >
          <slot name="default"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.banner-content {
  position: relative;

  .card-wrapper {
    max-height: 150px;
    height: 100%;
    background: rgb(133, 122, 178);
    background: linear-gradient(
        45deg,
        rgba(133, 122, 178, 0.7) 30%,
        rgba(133, 122, 178, 0.4318102240896359) 64%,
        rgba(255, 255, 255, 0) 100%
    );
    border-radius: 10px;
    box-shadow: 0 0 0 2px #573970;

    .card-container {
      padding: 30px 16px;
      min-height: 100px;
      height: 100%;

      .card-content {
        width: 100%;
      }
    }
  }

  .absolute {
    position: absolute;
    left: 15px;
    //top: 15px;
    display: flex;
    align-items: center;
  }
}

@media screen and (max-width: 960px) {
  .banner-content {
    .card-wrapper {
      max-height: 125px;

      .card-container {
        padding: 16px;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .banner-content {
    height: 100%;

    .card-wrapper {
      height: initial;

      .v-divider {
        height: auto !important;
      }
    }
  }
}

@media screen and (max-width: 460px) {
  .banner-content {
    padding: 0 !important;

    .card-wrapper {
      .card-container {
        padding: 6px;
      }
    }
  }
}
</style>
